import { ActionSheetProvider } from "@expo/react-native-action-sheet";
import Toast from "react-native-toast-message";
import { SafeAreaProvider } from "./../components";
import { BootstrapProps } from "./Bootstrap.types";
import { useBootstrap } from "./useBootstrap";
import { useAlert } from "../components/complex/alert/useAlert";
import { StoreProvider, StorePersistGate, StyleProvider } from "../structure";
import { BaseClassGroup } from "../structure/layout/style/StyleRegistry";
import ThemeProvider from "../structure/layout/theme/ThemeProvider";

export default function Bootstrap({ fonts, children, onLoad, classes, reducers, themes = {} }: BootstrapProps) {
  const { toastConfig } = useAlert();
  const { isLoading, store, persistor } = useBootstrap({ onLoad, fonts, reducers });

  return isLoading ? null : (
    <StoreProvider store={store}>
      <SafeAreaProvider>
        <StorePersistGate loading={null} persistor={persistor}>
          <ThemeProvider options={themes.options} initial={themes.initial}>
            <ActionSheetProvider>
              <StyleProvider classGroups={{ ...BaseClassGroup, ...(classes || {}) }}>
                {children}
                <Toast config={toastConfig} />
              </StyleProvider>
            </ActionSheetProvider>
          </ThemeProvider>
        </StorePersistGate>
      </SafeAreaProvider>
    </StoreProvider>
  );
}
